import { render } from "./AnalyticsModalPopup.vue?vue&type=template&id=1a1d375a&scoped=true&ts=true"
import script from "./AnalyticsModalPopup.vue?vue&type=script&lang=ts"
export * from "./AnalyticsModalPopup.vue?vue&type=script&lang=ts"

import "./AnalyticsModalPopup.vue?vue&type=style&index=0&id=1a1d375a&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1d375a"]])

export default __exports__